import mount from "core/mount"
import { CommandPalette } from "./command-palette"

mount({ CommandPalette })
